module.exports = __webpack_public_path__ + "static/img/adress4.7c86230.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/adress4.png
// module id = qHnA
// module chunks = 0